// 可await的命令式弹窗
import { OneModal } from '@yy/one-ui'

let modal: ReturnType<typeof OneModal.confirm> = null

/**
 * 可await的命令式弹窗，点击ok返回true，点击cancel返回false
 * 可以使用awaitConfirm.getModal() 获取当前弹窗实例
 * @param props
 * @returns
 */
export const awaitConfirm = ({
  throwError,
  ...props
}: Parameters<typeof OneModal.confirm>[0] & {
  throwError?: boolean
}) =>
  new Promise((res, reject) => {
    modal = OneModal.confirm({
      centered: true,
      ...props,
      onOk: async () => {
        modal = null
        const temp = await props.onOk?.()
        res(true)
        return temp
      },
      onCancel: async () => {
        modal = null
        const temp = await props.onCancel?.()
        if (throwError) {
          reject(false)
        } else {
          res(false)
        }
        return temp
      },
    })
  })

/**
 * 获取当前弹窗实例
 * @returns
 */
awaitConfirm.getModal = () => modal
